import classNames from "classnames";
import { uniqBy } from "lodash";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";

import css from "./days.module.scss";

interface IProps {
  rowCalendarsData: {
    exceptionDays: Record<string, any>[];
  };
  startDate: string;
  dayWidth: number;
}

const ExceptionDays = ({ rowCalendarsData, startDate, dayWidth }: IProps): JSX.Element => {
  const { utc } = useDateFormatter();
  const { exceptionDays } = rowCalendarsData;

  const renderedExceptionDays = uniqBy(exceptionDays, "date").map(({ date, working }) => {
    const utcDate = utc(date);
    const dayOffset = utcDate.diff(utc(startDate), "days");

    return (
      <div
        key={date}
        className={classNames(css.day, css.exceptionDay, {
          [css.notWorking]: !working,
          [css.working]: working
        })}
        style={{
          width: dayWidth - 1,
          left: dayWidth * dayOffset + 1
        }}
      />
    );
  });

  return <>{renderedExceptionDays}</>;
};

export default ExceptionDays;
